{
  "features": {
    "config": {
      "title": "Companion of the Lamb",
      "subtitle": "Twitch連携の設定",
      "sections": {
        "premiumSkins": {
          "title": "プレミアムスキン",
          "description": "この拡張機能を使用すると、視聴者が信者としてゲーム内に登場できるようになります。視聴者は信者をカスタマイズでき、ビッツを消費することでプレミアムスキンを使用することもできます。プレミアムスキンの使用に必要なビッツの量はあなたが設定できるほか、無料でスキンを使えるよう設定することも可能です。",
          "noBitsOption": "プレミアムスキン使用時にビッツを消費しない",
          "bitsFeatureNotAvailable": "あなたのチャンネルではビッツを使用できないため、視聴者はビッツを消費せず好きなスキンを選択できます。"
        }
      },
      "actions": {
        "save": "変更点を保存する"
      }
    },
    "followers": {
      "rafflePopup": {
        "title": "{{channelName}}の教団の一員になろう！",
        "subtitle": "抽選に選ばれた！",
        "timeRemaining": "残り時間： {{time}}",
        "message": "教団に加入すると、悪魔として聖戦に参加したり、子羊の教団の成長に貢献できたり、栄えある生贄に選ばれたりと、様々な栄光を享受できます！",
        "viewerLinkCta": "参加するには{あなたの情報を共有}してください。",
        "actions": {
          "joinRaffle": "教団への加入を希望します",
          "joinRaffleViewerHasAlreadyJoined": "抽選に参加しました。",
          "dismissRaffle": "興味ありません",
          "dismissRaffleViewerHasAlreadyJoined": "閉じる"
        },
        "raffleJoinedMessage": "あなたの意志を確認しました。教団の一員として選ばれた際には通知が行くことでしょう。このウィンドウは閉じても問題ありません。"
      },
      "followerBuilder": {
        "title": "信者を作ろう",
        "steps": {
          "intro": {
            "message": "教団にようこそ！ ここであなたが作成した信者はゲーム内に登場します。あなたの信者はいずれ死亡する運命にありますが、その一生は教団の大義のために捧げられることでしょう。",
            "actions": {
              "goToNextStep": "信者を作る"
            }
          },
          "skinSelection": {
            "actions": {
              "goToNextStep": "次へ"
            }
          },
          "colorSelection": {
            "actions": {
              "goToPreviousStep": "スキンに戻る",
              "goToNextStep": {
                "variationsForSkin": "次へ",
                "noVariationsForSkin": "信者を確定する"
              }
            }
          },
          "variationSelection": {
            "actions": {
              "goToPreviousStep": "色に戻る",
              "goToNextStep": "信者を確定する"
            }
          }
        }
      }
    },
    "helpOrHinder": {
      "help": "支援",
      "hinder": "妨害",
      "hhVotingFlyout": {
        "title": "支援するか妨害するか",
        "message": "投票しよう",
        "timeRemaining": "残り時間： {{time}}",
        "voteCount": "{{amount}} 票"
      },
      "outcomeVotingFlyout": {
        "title": "{{channelName}} を {{helpOrHinder}} 投票しよう！",
        "timeRemaining": "残り時間： {{time}}"
      }
    }
  }
}
